import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { LayoutContext } from '../../contexts/layout';
import { getBreakpointColumnsClass } from '../../helpers/layout';
import { formFieldsSelector } from '../../redux/selectors/forms';
import { IBaseLayout } from '../../types/layout';

function LayoutItemWrapper({ breakpointColumn, children, dependingFieldsValues }: React.PropsWithChildren<IBaseLayout>) {
    const dependingOnFormValues = dependingFieldsValues?.visibleWhen instanceof Object;

    const { layoutId } = useContext(LayoutContext);
    const breakpointColumnsClass = getBreakpointColumnsClass(breakpointColumn);
    const formValues = useSelector(formFieldsSelector(layoutId, Object.keys(dependingFieldsValues?.visibleWhen || {})));
    const [visible, setVisible] = useState(!dependingOnFormValues);

    const onFormValuesChange = () => {
        if (dependingFieldsValues?.visibleWhen instanceof Object) {
            let canShow = false;
            const { visibleWhen: visibilityDeps } = dependingFieldsValues;

            Object.keys(visibilityDeps).forEach((key) => {
                const formValue = formValues[key];
                if (Array.isArray(visibilityDeps[key])) {
                    const equals = [];

                    if (Array.isArray(formValue)) {
                        visibilityDeps[key].forEach((val: any) => {
                            if (formValue.includes(val)) {
                                equals.push(val);
                            }
                        });
                    } else {
                        visibilityDeps[key].forEach((val: any) => {
                            if (val === formValue) {
                                equals.push(val);
                            }
                        });
                    }

                    canShow = equals.length === visibilityDeps[key].length;
                } else {
                    canShow = formValues[key] === visibilityDeps[key];
                }
            });

            setVisible(canShow);
        }
    };

    useEffect(() => {
        onFormValuesChange();
    }, [dependingOnFormValues, Object.values(formValues).join(',')]);

    if (visible) {
        return (
            <div className={breakpointColumnsClass}>
                {children}
            </div>
        );
    }

    return null;
}

export default LayoutItemWrapper;
